module.exports = __webpack_public_path__ + "img/rdsc.98f1e5a3.png";